export const MAP_RELATED_KEYWORDS_ENTITY = {
  faculty: "researchers",
  institution: "institutions",
  unit: "units",
  venue: "venues",
};

export const carouselResponsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 4,
    partialVisibilityGutter: 60,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
    partialVisibilityGutter: 60,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
    partialVisibilityGutter: 40,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    partialVisibilityGutter: 30,
  },
};

export function generateEvenlySpaced(maxValue) {
  const minValue = 10;
  const distance = maxValue - minValue;

  if (distance < 5) {
    return Array.from({ length: distance + 1 }, (_, i) => minValue + i);
  }

  const step = Math.ceil(distance / 5);
  const isRoundtoFive = distance > 15;

  const result = [];
  for (let i = 0; i < 4; i++) {
    const num = minValue + i * step;
    result.push(isRoundtoFive ? Math.ceil(num / 5) * 5 : num);
  }
  result.push(maxValue);

  return result;
}

export function boldSubstrings(str, substrs) {
  return substrs.reduce((result, substr) => {
    const regex = new RegExp(`\\w*${substr}\\w*`, "gi");
    return result.replace(regex, (match) => `<strong>${match}</strong>`);
  }, str);
}

export function encryptObjectToAsterisk(obj) {
  const encryptedObject = {};
  for (const key in obj) {
    if (typeof obj[key] === "object") {
      encryptedObject[key] = encryptObjectToAsterisk(obj[key]);
    } else {
      encryptedObject[key] = `${encryptedObject[key]}`.replace(/[^\s]/g, "*");
    }
  }
  return Object.keys(encryptedObject).length > 0 ? encryptedObject : null;
}
